(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-nav"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const nav = document.querySelector('.collection-nav');
    const list = document.querySelector('.collection-nav__list');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      if ((this.predictiveSearch && this.predictiveSearch.isOpen) || this.searchModal?.isOpen()) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal || !this.searchModal.isOpen()) return;
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function () {
    const container = document.getElementById('Details-menu-drawer-container');
    if (!container) return; // Solo corre si nuestro drawer existe

    const drawerSummary = container.querySelector(':scope > summary');
    const navs = container.querySelectorAll('.menu-drawer__navigation[data-view]');

    function setActive(viewId) {
      navs.forEach((nav) => {
        const active = nav.getAttribute('data-view') === viewId;
        nav.classList.toggle('is-active', active);
        nav.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }

    if (![...navs].some((n) => n.classList.contains('is-active')) && navs[0]) {
      setActive(navs[0].getAttribute('data-view'));
    } else {
      navs.forEach((n) => n.setAttribute('aria-hidden', n.classList.contains('is-active') ? 'false' : 'true'));
    }

    function openDrawer() {
      return new Promise((resolve) => {
        if (container.open) return resolve();
        drawerSummary?.click();
        const wait = () => (container.open ? resolve() : requestAnimationFrame(wait));
        requestAnimationFrame(wait);
      });
    }

    document.addEventListener('click', (ev) => {
      const launcher = ev.target.closest('.js-drawer-launcher');
      if (!launcher) return;
      ev.preventDefault();

      const viewId = launcher.getAttribute('data-target');
      openDrawer().then(() => {
        requestAnimationFrame(() => {
          if (viewId) setActive(viewId);
          launcher.setAttribute('aria-expanded', 'true');
          const first = viewId
            ? container.querySelector(
                `.menu-drawer__navigation[data-view="${viewId}"] .menu-drawer__close-button, 
               .menu-drawer__navigation[data-view="${viewId}"] a, 
               .menu-drawer__navigation[data-view="${viewId}"] .menu-drawer__menu-item`
              )
            : null;
          first?.focus({ preventScroll: true });
        });
      });
    });

    // Dentro del drawer
    container.addEventListener('click', (ev) => {
      // Cerrar todo el drawer (primer nivel: botón superior con .js-drawer-close)
      const close = ev.target.closest('.js-drawer-close');
      if (close) {
        ev.preventDefault();
        drawerSummary?.click(); // usa la lógica nativa de Dawn
        return;
      }

      const switcher = ev.target.closest('.js-drawer-switch');
      if (switcher) {
        ev.preventDefault();
        const viewId = switcher.getAttribute('data-target');
        if (viewId) {
          setActive(viewId);
          const first = container.querySelector(
            `.menu-drawer__navigation[data-view="${viewId}"] a, 
           .menu-drawer__navigation[data-view="${viewId}"] .menu-drawer__menu-item`
          );
          first?.focus({ preventScroll: true });
        }
      }
    });

    // Si el <details> se cierra (overlay, Esc, etc.), no forzamos vistas
    container.addEventListener('toggle', () => {
      if (!container.open) {
        // si quieres, aquí podrías resetear a una vista por defecto
        // setActive(navs[0]?.getAttribute('data-view'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
